export const SITE_ORIGIN = 'https://assistance-video.fr';

/** Path without locale prefix, e.g. /articles/foo or / */
export function pathnameWithoutLocale(pathname) {
  if (pathname === '/en' || pathname === '/en/') {
    return '/';
  }
  if (pathname.startsWith('/en/')) {
    return pathname.slice(3) || '/';
  }
  return pathname || '/';
}

export function canonicalUrlForLocale(locale, pathWithoutLocale) {
  const p = pathWithoutLocale === '/' ? '' : pathWithoutLocale;
  if (locale === 'en') {
    return `${SITE_ORIGIN}/en${p}`;
  }
  return `${SITE_ORIGIN}${p || '/'}`;
}

export function hreflangAlternates(pathWithoutLocale) {
  const frUrl = `${SITE_ORIGIN}${pathWithoutLocale === '/' ? '/' : pathWithoutLocale}`;
  const enSuffix = pathWithoutLocale === '/' ? '' : pathWithoutLocale;
  const enUrl = `${SITE_ORIGIN}/en${enSuffix}`;
  return [
    { hrefLang: 'fr', href: frUrl },
    { hrefLang: 'en', href: enUrl },
    { hrefLang: 'x-default', href: frUrl },
  ];
}
